import React from "react";
import { HashLink as Link } from "react-router-hash-link";

export const Navbar = () => {
  return (
    <nav className="header__navbar" aria-label="Main navigation">
      <Link className="logo logoHeader" to="/#">
        {/* {" "}
        Carte Verte{" "} */}
        <img src="/images/logo.png" alt="Carte Verte logo" />
        <div className="brand-name">arte verte</div>
      </Link>
      <div className="header__navbar--links">

        <Link className="header__navbar--link" smooth to="/#features">
          À propos
        </Link>
        <Link className="header__navbar--link" smooth to="/#hiwb">
          Comment ça marche
        </Link>
        <Link className="header__navbar--link" smooth to="/#contactus">
          Contact
        </Link>
      </div>
      <div className="header__navbar--account">
        <Link
          className="loginButton"
          to={sessionStorage.getItem("loggedIn") ? "/mon-compte" : "/login"}
        >
          {sessionStorage.getItem("loggedIn") ? "Mon compte" : "Se connecter"}
        </Link>
        {sessionStorage.getItem("loggedIn") ? null : (
          <Link className="createButton" to="/signup">
            Adhérer
          </Link>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
